"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _form = _interopRequireDefault(require("./form"));
var APIIcon = function APIIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#939393",
    d: "M11.533 2.521a.937.937 0 0 1 .938 0l7.506 4.334c.29.167.469.477.469.812v8.667a.938.938 0 0 1-.47.812l-1.065.616a.469.469 0 0 1-.703-.407V8.633a.375.375 0 0 0-.187-.324L12.19 4.942a.375.375 0 0 0-.375 0L5.983 8.309a.375.375 0 0 0-.187.324v8.723c0 .36-.39.586-.703.405l-1.066-.615a.938.938 0 0 1-.469-.812V7.667c0-.335.179-.645.469-.812l7.506-4.334z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#5C5C5C",
    d: "M11.156 13.593a.281.281 0 0 1-.281-.28v-1.951c0-.134.072-.258.188-.325l.743-.43a.375.375 0 0 1 .375 0l.757.438c.115.066.187.19.187.324v1.943a.281.281 0 0 1-.281.281h-1.688z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#2E2E2E",
    d: "M13.125 20.887v-4.764a.281.281 0 0 0-.28-.282l-1.687-.01a.281.281 0 0 0-.283.28v4.77c0 .133.072.257.188.324l.756.437a.375.375 0 0 0 .375 0l.743-.43a.375.375 0 0 0 .188-.325z"
  }));
};
APIIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
var config = {
  angConfiguration: {
    typeURL: 'http://anypoint.com/vocabs/digital-repository#UnknownSpecAPIAsset',
    assetType: 'UnknownAPI'
  },
  owner: {
    gusTeam: 'TBD'
  },
  name: 'HTTP API',
  publication: {
    uiForm: _form.default,
    versioningAllowance: 'major',
    inferredBy: [{
      typeProperty: 'http-api'
    }],
    minimumInputSets: [{
      files: [],
      requiredProperties: ['apiVersion']
    }],
    customProperties: [{
      name: 'apiVersion',
      storeAsAttribute: true
    }],
    dependenciesRestrictions: {
      maximum: 0
    }
  },
  portal: {
    icon: APIIcon,
    color: '#a1b1b8' // robustBlue1
  },
  visibility: 'public',
  keywords: ['http', 'api']
};
var _default = exports.default = config;
//# sourceMappingURL=config.js.map